module.exports = __webpack_public_path__ + "img/marker_hiro.3b788bab.png";